package one.healthium.cali.presentation.feature.today.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import ifaandroid.apps.cali.composeapp.generated.resources.Res
import ifaandroid.apps.cali.composeapp.generated.resources.ic_notification_24
import loco.CALI_GREETINGS_USERNAME_FORMAT
import one.healthium.cali.paytone_18
import one.healthium.domain.user.models.UserProfileModel
import one.healthium.profile.ui.avatar.UserAvatar
import one.healthium.tasks.ui.DailyTasksBadge
import one.healthium.ui.compose.components.AppTextButton
import one.healthium.ui.compose.theme.AppTheme
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import androidx.compose.ui.tooling.preview.Preview

@Composable
internal fun TodayUserProfile(
    modifier: Modifier = Modifier,
    userProfile: UserProfileModel,
    onNotificationsClicked: () -> Unit,
) {
    Row(
        modifier = modifier.padding(horizontal = 12.dp, vertical = 10.dp),
    ) {
        UserAvatar(size = 50.dp)
        Spacer(Modifier.width(12.dp))
        UserName(modifier = Modifier.weight(1f), userProfile = userProfile)
        Notifications(onClick = onNotificationsClicked)
    }
}

@Composable
private fun UserName(
    modifier: Modifier = Modifier,
    userProfile: UserProfileModel,
) {
    Column(modifier = modifier) {
        Text(
            text = stringResource(loco.Res.string.CALI_GREETINGS_USERNAME_FORMAT, userProfile.name.orEmpty()),
            style = AppTheme.textStyles.paytone_18,
            maxLines = 1,
        )
        Text(
            text = rememberGreetingText().value,
            style = AppTheme.textStyles.secondary_14_400,
            maxLines = 1,
        )
    }
}

@Composable
private fun Notifications(
    modifier: Modifier = Modifier,
    onClick: () -> Unit,
) {
    AppTextButton(
        modifier = modifier,
        onClick = onClick,
    ) {
        Box {
            Image(
                painter = painterResource(Res.drawable.ic_notification_24),
                contentDescription = null,
            )
            DailyTasksBadge(
                modifier = Modifier
                    .align(Alignment.TopEnd)
                    .offset(x = -(2.dp), y = 3.dp)
            )
        }
    }
}

@Preview
@Composable
private fun TodayUserProfilePreview() {
    AppTheme {
        TodayUserProfile(
            userProfile = UserProfileModel.preview,
            onNotificationsClicked = {},
        )
    }
}
